export default __webpack_public_path__ + "static/media/loadGif.0ddc2ceb.gif";